//Node Modules
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

//BinaryForge Components

//3rd Party Components
import { Dropdown } from "primereact/dropdown";

//Atoms

//Helpers
import { buildDeviceGroups } from "../../helpers/deviceGroups";

//Other
const appElement = document.getElementsByClassName("app")[0];

//Picks a whole group of devices in one go - every CloudConnect, every FlowStop 2, or
//everything in and under a zone - so a report can be narrowed to one device type or one part
//of a site without ticking devices one at a time. The picker acts on the selection rather
//than holding a value of its own: choosing a group replaces the devices below, and the
//dropdown returns to its placeholder so it never claims a selection the user has since edited.
const DeviceQuickSelect = ({ devices, onSelect, disabled }) => {
	//Hooks
	const { t } = useTranslation();

	const options = useMemo(() => {
		const { types, zones } = buildDeviceGroups(devices);
		const groups = [];

		if (types.length > 0) {
			groups.push({
				label: t("report.form.quickSelect.type"),
				items: types.map((type) => ({
					key: `type:${type.family}`,
					label: `${t(`report.form.quickSelect.family.${type.family}`)} (${type.devices.length})`,
					devices: type.devices,
				})),
			});
		}

		if (zones.length > 0) {
			groups.push({
				label: t("report.form.quickSelect.zone"),
				items: zones.map((zone) => ({
					key: `zone:${zone.path}`,
					label: `${zone.label} (${zone.devices.length})`,
					devices: zone.devices,
				})),
			});
		}

		return groups;
	}, [devices, t]);

	return (
		<Dropdown
			appendTo={appElement}
			inputId="deviceQuickSelect"
			value={null}
			options={options}
			optionLabel="label"
			optionGroupLabel="label"
			optionGroupChildren="items"
			dataKey="key"
			filter
			disabled={disabled || options.length === 0}
			placeholder={t("report.form.quickSelect.placeholder")}
			onChange={(e) => onSelect(e.value?.devices ?? [])}
		/>
	);
};

export default DeviceQuickSelect;
